import React, { useEffect } from 'react';

import { LuxuryHomesHeader } from '../../commons/header';
import { LuxuryHomesBack } from '../../commons/back-button/component';

import { Routes } from '@share/constants';

import './style.scss';

interface IProps {
  children: React.ReactNode;
  route: Routes;

  childrenHero?: React.ReactNode;  
  className?: string;
  hideBackButton?: boolean;
  headerProps?: {
    fixed?: boolean;
    className?: string;
  };
}

export const LuxuryHomesMain: React.FC<IProps> = ({ children, route, headerProps, childrenHero, hideBackButton, className }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`luxury-homes-main ${className ? className : ''}`}>
      <LuxuryHomesHeader {...headerProps} />
      
      {childrenHero}
      
      {!hideBackButton && 
        <LuxuryHomesBack key={route} route={route} />}
      
      {children}
    </div>
  );
};
